import { css } from '@emotion/core';
import { variables, tokens } from '@domain-group/fe-brary';
var colors = tokens.colors,
  spacing = tokens.spacing;
export var bottomContent = /*#__PURE__*/css("display:flex;flex-direction:column;width:100%;align-items:flex-start;gap:", spacing.m, ";");
export var surroundingSuburbsWrapper = {
  name: "8atqhb",
  styles: "width:100%;"
};
export var propertyAlertSection = /*#__PURE__*/css("border-top:1px solid ", colors.neutral.trim.default, ";display:flex;flex-direction:column;gap:", spacing.s, ";width:100%;align-items:center;");
export var propertyAlert = /*#__PURE__*/css("padding-top:", spacing.s, ";font-size:", variables.font.smallFontSize, ";");